// extracted by mini-css-extract-plugin
export default {"productWrapper":"Product_productWrapper__AQ-jE","timeWrapper":"Product_timeWrapper__EvXig"};